import { MODAL_SHARE } from '@components/App/Modal/constants'
import { Tab } from '@components/App/Modal/Share/Share'
import { Button } from '@octopus-do/octopus-storybook'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useDispatch } from 'react-redux'

export const Share: React.FC = () => {
  const dispatch = useDispatch()

  const handleOnClick = () => {
    dispatch(
      openModal({
        modalType: MODAL_SHARE,
        modalProps: { activeTab: Tab.Access },
      })
    )
  }

  return (
    <Button
      priority="secondary"
      size="medium"
      label="Share"
      onClick={handleOnClick}
    />
  )
}
